import { Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import ApplicationLogoVertical from "../common/ApplicationLogoVertical";
import localize from "../../common/localize";

export default function NoDataPage({
  showAddButton,
  pageTitle,
  addButtonText,
  onAddButtonClick,
  noHeight,
}) {
  return (
    <div className="flex flex-col h-full justify-center content-center items-center">
      <div
        className={`flex flex-col w-96 justify-center content-center items-center my-2 ${
          !noHeight ? "h-96" : ""
        }`}
      >
        <ApplicationLogoVertical height={120} width={120} />
        <div className="my-2" />
        <Typography className="text-10 text-center">{pageTitle}</Typography>
        <div className="my-2" />
        <Typography fontSize={20} align="center" />
        {showAddButton && (
          <Button
            color="success"
            variant="contained"
            className="btn-success app_general_button_data my-2 h-10"
            onClick={() => {
              onAddButtonClick();
            }}
          >
            <span className="text-xs mr-2">
              {addButtonText ?? localize.add}
            </span>
            <Add className="text-sm" />
          </Button>
        )}
      </div>
    </div>
  );
}
